import React, { useEffect, useRef, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
	XEditButtonIcon,
	XThemeFilterCards,
	XThemeFilterButton,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
	Tooltip,
	Carousel,
	Progress,
	Grid,
	Skeleton,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVABatchProgressCard,
	XThemeVoiceBatchDetails,
	XThemeTotalCaseGraph,
	CustomSevenStepProgress,
	CustomCarousel,
	CustomProgress2Wrapper,
	CustomProgress2,
	XTheme2MiddleCard,
	XTheme2FilledCard,
} from '../../VoiceAssistanceStyle';
import {
	EyeOutlined,
	InfoCircleOutlined,
	PlusCircleOutlined,
} from '@ant-design/icons';
import {
	XThemeBulkDetailsCard,
	XThemeBulkDetailsNoCases,
	XThemeBulkDetailsRevenueImpact,
	XThemeBulkOverallProgress,
	XThemeBulkTags,
	XThemeCustomLoader,
	XThemeRefreshBTN,
} from '../../../Batches/BatchesStyle';
import { toTitleCase, truncateString } from '../../../../utils/helper';
import styled from 'styled-components';
import { XTheme2Button } from '../../../../styles/GlobalThemeStyleCQ';

// const dataSource = [
// 	{
// 		key: '1',
// 		sr: '#',
// 		case_name: 'Lucas Garcia',
// 		case_id: 'ST.452011',
// 		insurance_company: 'CGS Administration, LLC',
// 		hospital: 'ST. Joseph's',
// 	},
// ];
const dataSource = Array.from({ length: 10 }).map((_, i) => ({
	key: i,
	sr: <div className="tablecount">lg</div>,
	case_name: `Lucas Garcia ${i}`,
	case_id: `ST.45201${i}`,
	insurance_company: `CGS Administration, LLC ${i}`,
	hospital: `ST. Joseph's ${i}`,
}));
const columns2 = [
	{
		title: '#',
		dataIndex: 'sr',
		key: 'sr',
	},
	{
		title: 'Case',
		dataIndex: 'case_name',
		key: 'case_name',
	},
	{
		title: 'Case ID',
		dataIndex: 'case_id',
		key: 'case_id',
	},
	{
		title: 'Insurance Company',
		dataIndex: 'insurance_company',
		key: 'insurance_company',
	},
	{
		title: 'Hospital',
		dataIndex: 'hospital',
		key: 'hospital',
	},
];

const VACard2 = (props) => {
	const {
		batchData,
		handleClear,
		filters,
		handleStatusClick,
		setFilters,
		setTableLoading,
		tableLoading,
		casesData,
		handleTableChange,
		id,
		columns,
		isFiltersActive,
		getStatusTitle,
		handleSearch,
		showTopCards,
	} = props;

	// Add state for carousel current slide
	const [currentSlide, setCurrentSlide] = useState(0);

	// Define dynamic segments based on batch status counts
	const stepData = useMemo(() => {
		if (!batchData?.batch_status_counts) return [];

		// Status to color mapping
		const statusColors = {
			letter_prepared: '#46c7a8',
			human_intervention: '#72aeff',
			rejected: '#e48383',
			pending: '#f7c542',
			processing: '#3ac5de',
			inconclusive: '#68c17a',
		};

		// Calculate segments from batch_status_counts
		const segments = Object.entries(batchData.batch_status_counts)
			.filter(([key, value]) => key !== 'total' && value > 0)
			.map(([status, count]) => ({
				status,
				color: statusColors[status] || '#99b65f',
				width: (count / batchData.batch_status_counts.total) * 100,
			}));

		return segments;
	}, [batchData]);

	const formatNumber = (cost) => {
		if (cost === 0) {
			return '0';
		}
		const suffixes = ['K', 'M', 'B', 'T'];
		let formattedCost = cost;
		let suffix = '';

		for (const s of suffixes) {
			if (formattedCost < 1000) {
				break;
			}
			formattedCost /= 1000;
			suffix = s;
		}

		return `${formattedCost}${suffix}`;
	};

	// Calculate SVG path for circular segments
	const createArcPath = (startAngle, endAngle, radius) => {
		// Special case for full or near-full circle
		if (Math.abs(endAngle - startAngle) >= 359.9) {
			// Use two arcs to create a full circle instead of one
			const halfAngle = startAngle + (endAngle - startAngle) / 2;
			const halfRad = ((halfAngle - 90) * Math.PI) / 180;
			const startRad = ((startAngle - 90) * Math.PI) / 180;
			const endRad = ((endAngle - 90) * Math.PI) / 180;
			
			const x1 = radius * Math.cos(startRad);
			const y1 = radius * Math.sin(startRad);
			const xMid = radius * Math.cos(halfRad);
			const yMid = radius * Math.sin(halfRad);
			const x2 = radius * Math.cos(endRad);
			const y2 = radius * Math.sin(endRad);
			
			return `M ${x1} ${y1} A ${radius} ${radius} 0 1 1 ${xMid} ${yMid} A ${radius} ${radius} 0 1 1 ${x2} ${y2} L 0 0 Z`;
		}
		
		// Regular case for partial circles
		const startRad = ((startAngle - 90) * Math.PI) / 180;
		const endRad = ((endAngle - 90) * Math.PI) / 180;

		const x1 = radius * Math.cos(startRad);
		const y1 = radius * Math.sin(startRad);
		const x2 = radius * Math.cos(endRad);
		const y2 = radius * Math.sin(endRad);

		const largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;

		return `M ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} L 0 0 Z`;
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			{showTopCards && (
				<>
					<Row gutter={[15, 15]}>
						<Col xs={24} sm={24} md={24} lg={12} xl={12}>
							<XThemeVoiceBatchDetails>
								<Row gutter={[15, 15]}>
									<Col
										xs={24}
										sm={24}
										md={24}
										lg={12}
										xl={12}
									>
										<div className="cardTitle">
											Overview{' '}
											{/* <span>
								{batchData?.batch_details?.total_cases || 0}{' '}
								Cases
							</span> */}
											{/* <Tooltip title="prompt text">
								<InfoCircleOutlined />
							</Tooltip> */}
										</div>
									</Col>
									<Col
										xs={24}
										sm={24}
										md={24}
										lg={12}
										xl={12}
										className="text-end"
									>
										{isFiltersActive() && (
											<XTheme2Button
												size="middle"
												className="h-100 noBackground"
												onClick={handleClear}
											>
												Clear
											</XTheme2Button>
										)}
									</Col>
								</Row>
								<Row
									gutter={[15, 15]}
									className="align-items-center mt-3"
								>
									<Col xs={24} sm={12}>
										<img
											className="img-fluid"
											src="/images/batch-graph.svg"
											alt="graph"
										/>
										<div className="cardNumbers">
											{batchData?.batch_details
												?.total_cases || 0}{' '}
										</div>
										<div className="cardTitle">
											Total Cases
										</div>
									</Col>
									<Col
										xs={24}
										sm={12}
										className="my-4 my-md-0"
									>
										<CustomSevenStepProgress>
											<svg
												width="150"
												height="150"
												viewBox="-40 -40 80 80"
											>
												{stepData.map((step, index) => {
													const cumulativeWidth =
														stepData
															.slice(0, index)
															.reduce(
																(sum, s) =>
																	sum +
																	s.width,
																0,
															);

													const startAngle =
														(360 / 100) *
														cumulativeWidth;
													const endAngle =
														(360 / 100) *
														(cumulativeWidth +
															step.width);

													return (
														<path
															key={index}
															d={createArcPath(
																startAngle,
																endAngle,
																35,
															)}
															fill={step.color}
															stroke="white"
															strokeWidth="1"
														/>
													);
												})}
											</svg>
											<div className="progress-center">
												Total Cases
											</div>
										</CustomSevenStepProgress>
									</Col>
								</Row>
							</XThemeVoiceBatchDetails>
						</Col>
						<Col xs={24} sm={24} md={24} lg={12} xl={12}>
							<XThemeVoiceBatchDetails>
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={24}>
										<div className="cardTitle">
											Overall Progress{' '}
											{/* <Tooltip title="prompt text">
										<InfoCircleOutlined />
									</Tooltip> */}
										</div>
									</Col>
									<Col xs={12}>
										{batchData?.progress_percentage ===
										100 ? (
											<div className="cardTitle">
												<span>Completed</span>
											</div>
										) : (
											<div className="cardTitle">
												<span>In Progress</span>
											</div>
										)}
										<div className="cardText mt-2">
											Assess the progress of your case
											activities.
										</div>
									</Col>
									<Col xs={12} className="text-center">
										<CustomProgress2Wrapper>
											<CustomProgress2
												$strokewidth={20}
												type="circle"
												percent={
													batchData?.progress_percentage
												}
												strokeColor={{
													'0%': '#FFFFFF',
													'100%': '#61AF4A',
												}}
												trailColor="rgba(0, 0, 0, 0.04)"
												strokeWidth={15}
												size={120}
												format={(percent) => (
													<span>{percent}%</span>
												)}
											/>
										</CustomProgress2Wrapper>
									</Col>
								</Row>
							</XThemeVoiceBatchDetails>
						</Col>
					</Row>
					<Row gutter={[15, 15]} className="mt-3">
						<Col xs={24}>
							<XTheme2FilledCard>
								<div
									className={`cardItem ${
										filters.status === 'pending'
											? 'active'
											: ''
									}`}
									// Add active className after clicked on cardItem
									// className="cardItem"
									onClick={() => handleStatusClick('pending')}
								>
									<Space.Compact
										direction="vertical"
										className="me-2"
									>
										<img src="/images/bulk-pending-icon.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Pending</h4>
										<h1>
											{batchData?.batch_status_counts
												?.pending || 0}
										</h1>
									</Space.Compact>
								</div>
								<div
									className={`cardItem ${
										filters.status === 'processing'
											? 'active'
											: ''
									}`}
									onClick={() =>
										handleStatusClick('processing')
									}
								>
									<Space.Compact
										direction="vertical"
										className="me-2"
									>
										<img src="/images/bulk-inprogress-icon.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>In Progress</h4>
										<h1>
											{batchData?.batch_status_counts
												?.processing || 0}
										</h1>
									</Space.Compact>
								</div>
								<div
									className={`cardItem ${
										filters.status === 'human_intervention'
											? 'active'
											: ''
									}`}
									onClick={() =>
										handleStatusClick('human_intervention')
									}
								>
									<Space.Compact
										direction="vertical"
										className="me-2"
									>
										<img src="/images/bulk-require-user-input-icon.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Require User Input</h4>
										<h1>
											{batchData?.batch_status_counts
												?.human_intervention || 0}
										</h1>
									</Space.Compact>
								</div>
								<div
									className={`cardItem ${
										filters.status === 'inconclusive'
											? 'active'
											: ''
									}`}
									onClick={() =>
										handleStatusClick('inconclusive')
									}
								>
									<Space.Compact
										direction="vertical"
										className="me-2"
									>
										<img src="/images/bulk-inconclusive-icon.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Inconclusive</h4>
										<h1>
											{batchData?.batch_status_counts
												?.inconclusive || 0}
										</h1>
									</Space.Compact>
								</div>
								<div
									className={`cardItem ${
										filters.status === 'letter_prepared'
											? 'active'
											: ''
									}`}
									onClick={() =>
										handleStatusClick('letter_prepared')
									}
								>
									<Space.Compact
										direction="vertical"
										className="me-2"
									>
										<img src="/images/bulk-letter-prepared-icon.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Letter Prepared</h4>
										<h1>
											{batchData?.batch_status_counts
												?.letter_prepared || 0}
										</h1>
									</Space.Compact>
								</div>
								<div
									className={`cardItem ${
										filters.status === 'rejected'
											? 'active'
											: ''
									}`}
									onClick={() =>
										handleStatusClick('rejected')
									}
								>
									<Space.Compact
										direction="vertical"
										className="me-2"
									>
										<img src="/images/bulk-rejected-icon.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Not Covered</h4>
										<h1>
											{batchData?.batch_status_counts
												?.rejected || 0}
										</h1>
									</Space.Compact>
								</div>
							</XTheme2FilledCard>
						</Col>
						{/* Removed slider for now */}
						{/* <Col xs={24}>
							<div
								style={{
									overflow: 'hidden',
									position: 'relative',
								}}
							>
								<CustomCarousel
									arrows
									infinite={false}
									current={currentSlide}
									onChange={(slide) => setCurrentSlide(slide)}
									dots={false}
									slidesToShow={isMobile ? 1 : 1.9}
									slidesToScroll={1}
								>
									<div>
										<div
											className="cardItem"
											onClick={() =>
												handleStatusClick('pending')
											}
										>
											<Space.Compact
												direction="vertical"
												className="me-2"
											>
												<img src="/images/bulk-pending-icon.svg" />
											</Space.Compact>
											<Space.Compact direction="vertical">
												<h4>Pending</h4>
												<h1>
													{batchData
														?.batch_status_counts
														?.pending || 0}
												</h1>
											</Space.Compact>
										</div>
									</div>
									<div>
										<div
											className="cardItem"
											onClick={() =>
												handleStatusClick('processing')
											}
										>
											<Space.Compact
												direction="vertical"
												className="me-2"
											>
												<img src="/images/bulk-inprogress-icon.svg" />
											</Space.Compact>
											<Space.Compact direction="vertical">
												<h4>In Progress</h4>
												<h1>
													{batchData
														?.batch_status_counts
														?.processing || 0}
												</h1>
											</Space.Compact>
										</div>
									</div>
									<div>
										<div
											className="cardItem"
											onClick={() =>
												handleStatusClick(
													'human_intervention',
												)
											}
										>
											<Space.Compact
												direction="vertical"
												className="me-2"
											>
												<img src="/images/bulk-require-user-input-icon.svg" />
											</Space.Compact>
											<Space.Compact direction="vertical">
												<h4>Require User Input</h4>
												<h1>
													{batchData
														?.batch_status_counts
														?.human_intervention ||
														0}
												</h1>
											</Space.Compact>
										</div>
									</div>
									<div>
										<div
											className="cardItem"
											onClick={() =>
												handleStatusClick(
													'inconclusive',
												)
											}
										>
											<Space.Compact
												direction="vertical"
												className="me-2"
											>
												<img src="/images/bulk-inconclusive-icon.svg" />
											</Space.Compact>
											<Space.Compact direction="vertical">
												<h4>Inconclusive</h4>
												<h1>
													{batchData
														?.batch_status_counts
														?.inconclusive || 0}
												</h1>
											</Space.Compact>
										</div>
									</div>

									<div>
										<div
											className="cardItem"
											onClick={() =>
												handleStatusClick(
													'letter_prepared',
												)
											}
										>
											<Space.Compact
												direction="vertical"
												className="me-2"
											>
												<img src="/images/bulk-letter-prepared-icon.svg" />
											</Space.Compact>
											<Space.Compact direction="vertical">
												<h4>Letter Prepared</h4>
												<h1>
													{batchData
														?.batch_status_counts
														?.letter_prepared || 0}
												</h1>
											</Space.Compact>
										</div>
									</div>

									<div>
										<div
											className="cardItem me-3"
											onClick={() =>
												handleStatusClick('rejected')
											}
										>
											<Space.Compact
												direction="vertical"
												className="me-2"
											>
												<img src="/images/bulk-rejected-icon.svg" />
											</Space.Compact>
											<Space.Compact direction="vertical">
												<h4>Not Covered</h4>
												<h1>
													{batchData
														?.batch_status_counts
														?.rejected || 0}
												</h1>
											</Space.Compact>
										</div>
									</div>
								</CustomCarousel>
							</div>
						</Col> */}
					</Row>
					<XTheme2MiddleCard className="mt-3">
						<Row gutter={[15, 15]}>
							<Col xs={24} sm={24} md={12} lg={12} xl={8}>
								<div className="cardBorder">
									<Space.Compact
										direction="vertical"
										className="me-3"
									>
										<img src="/images/denial-amount-icon.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Denial Amount ($)</h4>
										<h1>
											$
											{formatNumber(
												batchData?.case_amounts
													?.denial_amount || 0,
											)}
										</h1>
									</Space.Compact>
								</div>
							</Col>
							<Col xs={24} sm={24} md={12} lg={12} xl={8}>
								<div className="cardBorder">
									<Space.Compact
										direction="vertical"
										className="me-3"
									>
										<img src="/images/potential.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Potential Recovery ($)</h4>
										<h1>
											$
											{formatNumber(
												batchData?.case_amounts
													?.potential_recovery || 0,
											)}
										</h1>
									</Space.Compact>
								</div>
							</Col>
							<Col xs={24} sm={24} md={24} lg={24} xl={8}>
								<div className="cardBorder border-0">
									<Space.Compact
										direction="vertical"
										className="me-3"
									>
										<img src="/images/writeoff.svg" />
									</Space.Compact>
									<Space.Compact direction="vertical">
										<h4>Write Off ($)</h4>
										<h1>
											$
											{formatNumber(
												batchData?.case_amounts
													?.write_off || 0,
											)}
										</h1>
									</Space.Compact>
								</div>
							</Col>
						</Row>
					</XTheme2MiddleCard>
				</>
			)}
			<XThemeVoiceAssTableCard className="mt-3">
				<div className="hasPadding">
					<Row gutter={[15, 15]} className="align-items-center">
						<Col xs={24} sm={12} lg={8}>
							<div className="tableTitle">
								{getStatusTitle(filters?.status)}
							</div>
						</Col>
						<Col xs={24} sm={12} lg={8} className="text-end">
							{isFiltersActive() && (
								<XTheme2Button
									size="middle"
									className="h-100 noBackground"
									onClick={handleClear}
								>
									Clear
								</XTheme2Button>
							)}
						</Col>
						<Col xs={24} sm={12} lg={8} className="text-end">
							
								<XThemeInputText
									size="large"
									allowClear
									placeholder="Search for Cases"
									onChange={(e) =>
										handleSearch(e.target.value)
									}
								/>
								{/* <XThemeFilterButton>Search</XThemeFilterButton> */}
							
							
						</Col>
					</Row>
				</div>
				<XThemeVoiceAssTable
					loading={tableLoading}
					columns={columns}
					dataSource={casesData}
					scroll={{ x: 791 }}
					onChange={handleTableChange}
					onRow={(record) => ({
						className: record.status[0],
					})}
					pagination={{
						total: batchData?.pagination?.total || 0,
						current: filters?.page,
						pageSize: filters?.limit,
						showSizeChanger: true,
						// showTotal: (total, range) =>
						// 	`${range[0]}-${range[1]} of ${total} items`,
					}}
				/>
			</XThemeVoiceAssTableCard>
		</>
	);
};

export default VACard2;
